import api from '@/lib/hippo'
import Vue from 'vue'
import Enrollment from '@/models/enrollment'
import AdditionalResource from '@/models/additional_resource'
import Forum from '@/models/forum'
import Topic from '@/models/topic'
import Post from '@/models/post'
import User from '@/models/user'

function initialState() {
    return {
        //sections: {},
        forums: {},
        topics: {},
        Pagination: {},
        section: {},
        posts:{},
        users:{},
        section_post_count:{}
    };
}
const state = initialState;

const actions = {

    fetchForums ({commit, state, rootGetters}, {page, per_page}) {  
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                 api.fetchForums(rootGetters.apiToken, page, per_page).then( (response) => {
                     let forums = Forum.from(response.data);
                     commit ('addForums', forums);
                    resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
    getSection ({commit, state, rootGetters},{forum_id, section_id}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getSection(rootGetters.apiToken, forum_id, section_id).then( (response) => {
                    let section = Section.from(response.data)
                    commit ('addSection', section);
                    resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
    fetchSectionPostCount({ commit, state, rootGetters }, { forum_id }) {

        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getSectionPostCount(rootGetters.apiToken, forum_id).then((response) => {
                    let data = response.data;
                    commit('updateSectionPostCount', data);
                }).catch((err) => reject(err));
            } else {
                reject(new Error((!rootGetters.apiToken) ? 'You are no longer logged in.' : 'Missing required parameter.'));
            }
        });
    },
    fetchTopics ({commit, state, rootGetters}, {forumId, sectionId, page, per_page}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.fetchTopics(rootGetters.apiToken, forumId, sectionId, page, per_page).then( (response) => {
                    let topics = Topic.from(response.data);
                    commit ('addTopics', {topics: topics, forumId: forumId, sectionId: sectionId});
                    commit('setPagination', response.data.meta);
                     resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
    createTopic ({commit, state, rootGetters}, {forumId, sectionId , topic }) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.createTopic(rootGetters.apiToken, forumId, sectionId, topic).then( (response) => {
                    let topic = Topic.from(response.data);
                     commit ('appendTopic', topic);
                     resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
    fetchPosts ({commit, state, rootGetters}, {forumId, topicId, page, per_page}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.fetchPosts(rootGetters.apiToken, forumId, topicId, page, per_page).then( (response) => {
                    let posts = Post.from(response.data);
                    let users = User.from(response.data);
                    
                    commit ('addPosts', posts);
                    commit ('addUsers', users);
                    commit('setPagination', response.data.meta);
                    resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
    createPost ({commit, state, rootGetters}, {forumId, topicId, post }) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.createPost(rootGetters.apiToken, forumId, topicId, post).then( (response) => {
                    let post = Post.from(response.data);
                    let user = User.from(response.data);
                     commit ('appendPost', post);
                     commit ('appendUser',user);
                     resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },

    createModerationAction ({commit, state, rootGetters}, {forum_id, post_id, moderation_action}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.createModerationAction(rootGetters.apiToken, forum_id, post_id, moderation_action).then( (response) => {
                    if(response.status==201){
                        commit('modifyPost', post_id);
                    }
                    resolve(true);
                }).catch((err) => reject(err) );
            } else {
				reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
			}
        });
    },
  
};

const mutations = {
    addForums: (state, forums) => {
        Vue.set(state, 'forums', forums);
    },
    addSections: (state, section) => {
        Vue.set(state, 'sections', sections);
    },
    addSection: (state, section) => {
        Vue.set(state, 'section', section);
    },
    addTopics: (state, {topics, forumId, sectionId}) => {
        Vue.set(state, 'topics', topics);
    },
    appendTopic: (state, topic) => {
        if (!state.topics) Vue.set(state, 'topics', {});
        Vue.set(state.topics, topic.id, topic);
    },
    setPagination: (state, data) => {
		Vue.set(state, 'Pagination', data);
	},
    addPosts: (state, posts) => {
        Vue.set(state, 'posts', posts);
    },
    appendPost: (state, post) => {
        if (!state.posts) Vue.set(state, 'posts', {});
        Vue.set(state.posts, post.id, post);
    },
    modifyPost: (state, postId) => {
        let post = state.posts[postId];
        post.body = "This post was flagged for review."
        Vue.set(state.posts, postId, post);
    },
    addUsers: (state, users) => {
        Vue.set(state, 'users', users);
    },
    appendUser: (state, user) => {
        if (!state.users) Vue.set(state, 'users', {});
        Vue.set(state.users, user.id, user);
    },
    updateSectionPostCount: (state, data) =>{
        // Vue.set(state,"section_post_count", data);
        if (!state.section_post_count) Vue.set(state, 'section_post_count', {});
        let temp = { ...state.section_post_count, ...data};
        Vue.set(state,"section_post_count", temp);
    }
    
};

export default {
    state,
    actions,
    mutations
}
